import { useWbsItemSearchConditionV2SerializeService } from '../../transform-service/wbsItemSearchConditionV2SerializeService'
import { WbsItemSearchConditionV2VO } from '../../../domain/value-object/WbsItemSearchConditionV2Vo'
import { useUiStateStorageService } from '../../../infrastructure/adaptors/uiStateStorageServiceAdaptor'
import { useWbsItemSearchConditionV2Factory } from '../../factories/wbsItemSearchConditionV2Factory'

export type WbsItemSearchConditionV2StorageService = {
  save: (
    functionUuid: string,
    projectUuid: string,
    condition: WbsItemSearchConditionV2VO
  ) => Promise<void>
  fetch: (
    functionUuid: string,
    projectUuid: string
  ) => Promise<WbsItemSearchConditionV2VO | undefined>
}

// This is used for temporary store.
const bulkSheetSearchCondisionState = 'BULK_SHEET_SEARCH_CONDITION_STATE'

export const useWbsItemSearchConditionV2StorageService =
  (): WbsItemSearchConditionV2StorageService => {
    const uiStateStorageService = useUiStateStorageService()
    const factory = useWbsItemSearchConditionV2Factory()
    const transformer = useWbsItemSearchConditionV2SerializeService()

    const toTemporaryKey = (projectUuid: string) =>
      `${bulkSheetSearchCondisionState}-${projectUuid}`

    const save = async (
      functionUuid: string,
      projectUuid: string,
      condition: WbsItemSearchConditionV2VO
    ): Promise<void> => {
      const storedObject = transformer.fromVoToStoredObject(condition)
      uiStateStorageService.save(
        functionUuid,
        toTemporaryKey(projectUuid),
        'USER',
        storedObject
      )
    }

    const fetch = async (
      functionUuid: string,
      projectUuid: string
    ): Promise<WbsItemSearchConditionV2VO | undefined> => {
      const storedCondition = await uiStateStorageService.fetch(
        functionUuid,
        toTemporaryKey(projectUuid),
        'USER'
      )
      if (!storedCondition) return undefined
      return factory.fromApiResponseToVo(storedCondition)
    }

    return {
      save,
      fetch,
    }
  }
